<template>
  <a-card>
    <div class="ant-descriptions-title">
      Permission HR
    </div>
    <div style="margin-bottom: 20px;">
      <a-form-model>
        <a-form-model-item label="Leave app">
          <SelectUser
            v-model="workLeaveApprovers"
            :initialDatas="users ? users : []"
            :selectProps="{
              mode: 'multiple',
              placeholder: 'Select users',
              value: workLeaveApprovers,
              style: { width: '100%' },
            }"
            @change="
              () => {
                if (!isChanged) isChanged = true;
              }
            "
            :variablesQuery="{ hasEmployee: undefined }"
          />
        </a-form-model-item>
      </a-form-model>

      <div style="text-align: right; margin-top: 10px;" v-if="isChanged">
        <a-button style="margin-right: 10px;" @click="resetChanged">
          Cancel
        </a-button>
        <a-button
          type="primary"
          :loading="loadingBtn"
          @click="onUpdateEmployeeConfig"
        >
          Update
        </a-button>
      </div>
    </div>

    <div>
      <a-form-model>
        <a-form-model-item label="Overtime app">
          <SelectUser
            v-model="workOvertimeApprovers"
            :initialDatas="
              userWorkOvertimeApprovers ? userWorkOvertimeApprovers : []
            "
            :selectProps="{
              mode: 'multiple',
              placeholder: 'Select users',
              value: workOvertimeApprovers,
              style: { width: '100%' },
            }"
            @change="
              () => {
                if (!isChangedWorkOvertime) isChangedWorkOvertime = true;
              }
            "
            :variablesQuery="{ hasEmployee: undefined }"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div
      style="text-align: right; margin-top: 10px;"
      v-if="isChangedWorkOvertime"
    >
      <a-button style="margin-right: 10px;" @click="isChangedWorkOvertime">
        Cancel
      </a-button>
      <a-button
        type="primary"
        :loading="loadingBtn"
        @click="onUpdateEmployeeConfigWorkOvertime"
      >
        Update
      </a-button>
    </div>

    <div>
      <a-form-model>
        <a-form-model-item label="Travel request app">
          <SelectUser
            v-model="travelRequestApprovers"
            :initialDatas="
              userTravelRequestApprovers ? userTravelRequestApprovers : []
            "
            :selectProps="{
              mode: 'multiple',
              placeholder: 'Select users',
              value: travelRequestApprovers,
              style: { width: '100%' },
            }"
            @change="
              () => {
                if (!isChangedTravelRequest) isChangedTravelRequest = true;
              }
            "
            :variablesQuery="{ hasEmployee: undefined }"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div
      style="text-align: right; margin-top: 10px;"
      v-if="isChangedTravelRequest"
    >
      <a-button
        style="margin-right: 10px;"
        @click="resetTravelRequestApprovals"
      >
        Cancel
      </a-button>
      <a-button
        type="primary"
        :loading="loadingBtn"
        @click="onUpdateEmployeeConfigTravelRequest"
      >
        Update
      </a-button>
    </div>
  </a-card>
</template>
<script>
import query from "../constant/query";
import debounce from "lodash/debounce";
import SelectUser from "@/components/common/user/select";

export default {
  components: { SelectUser },
  data() {
    return {
      employeeConfig: {},
      loadingList: false,
      users: [],
      userWorkOvertimeApprovers: [],
      userTravelRequestApprovers: [],
      loadingUser: false,
      workLeaveApprovers: [],
      workOvertimeApprovers: [],
      travelRequestApprovers: [],
      isChanged: false,
      loadingBtn: false,
      isChangedWorkOvertime: false,
      isChangedTravelRequest: false,
    };
  },
  created() {
    this.onGetEmployeeConfig();
  },
  methods: {
    onGetEmployeeConfig() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getEmployeeConfig,
        })
        .then(({ data }) => {
          if (data?.getEmployeeConfig) {
            this.employeeConfig = { ...data.getEmployeeConfig };
            if (data.getEmployeeConfig?.workLeaveApprovers?.length > 0) {
              this.workLeaveApprovers = [
                ...data.getEmployeeConfig.workLeaveApprovers.map((e) => e.id),
              ];
              this.users = [...data.getEmployeeConfig.workLeaveApprovers];
            }

            if (data.getEmployeeConfig?.workOvertimeApprovers?.length > 0) {
              this.workOvertimeApprovers = [
                ...data.getEmployeeConfig.workOvertimeApprovers.map(
                  (e) => e.id
                ),
              ];

              this.userWorkOvertimeApprovers = [
                ...data.getEmployeeConfig.workOvertimeApprovers,
              ];
            }

            if (data.getEmployeeConfig?.travelRequestApprovers?.length > 0) {
              this.travelRequestApprovers = [
                ...data.getEmployeeConfig.travelRequestApprovers.map(
                  (e) => e.id
                ),
              ];

              this.userTravelRequestApprovers = [
                ...data.getEmployeeConfig.travelRequestApprovers,
              ];
            }
          }
          this.loadingList = false;
        })
        .catch((err) => {
          this.loadingList = false;
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log(
            "Lấy danh sách cấu hình nhân viên duyệt không thành công!",
            err
          );
        });
    },
    onUpdateEmployeeConfig() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateEmployeeConfig,
          variables: {
            workLeaveApproverIds: this.workLeaveApprovers,
          },
        })
        .then(({ data }) => {
          if (data?.updateEmployeeConfig) {
            this.refreshAfterUpdated(data.updateEmployeeConfig);
          }
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Cập nhật không thành công!", err);
        });
    },

    onUpdateEmployeeConfigWorkOvertime() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateEmployeeConfig,
          variables: {
            workOvertimeApproverIds: this.workOvertimeApprovers,
          },
        })
        .then(({ data }) => {
          if (data?.updateEmployeeConfig) {
            this.refreshAfterUpdatedWorkOvertime(data.updateEmployeeConfig);
          }
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Cập nhật không thành công!", err);
        });
    },

    onUpdateEmployeeConfigTravelRequest() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateEmployeeConfig,
          variables: {
            travelRequestApproverIds: this.travelRequestApprovers,
          },
        })
        .then(({ data }) => {
          if (data?.updateEmployeeConfig) {
            this.refreshAfterUpdatedTravelRequest(data.updateEmployeeConfig);
          }
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Cập nhật không thành công!", err);
        });
    },

    startReset(field) {
      return this.employeeConfig?.[field]?.length > 0
        ? [...this.employeeConfig[field].map((e) => e.id)]
        : [];
    },

    resetChanged() {
      this.isChanged = false;
      this.startReset("workLeaveApprovers");
    },
    resetTravelRequestApprovals() {
      this.isChangedTravelRequest = false;
      this.startReset("travelRequestApprovers");
    },

    resetWorkOvertimeApprovals() {
      this.isChangedWorkOvertime = false;
      this.startReset("workOvertimeApprovers");
    },

    refreshAfterUpdated(employeeConfig) {
      this.employeeConfig = { ...employeeConfig };
      this.isChanged = false;
    },

    refreshAfterUpdatedWorkOvertime(employeeConfig) {
      this.employeeConfig = { ...employeeConfig };
      this.isChangedWorkOvertime = false;
    },

    refreshAfterUpdatedTravelRequest(employeeConfig) {
      this.employeeConfig = { ...employeeConfig };
      this.isChangedTravelRequest = false;
    },
  },
};
</script>
<style lang="css" scoped></style>
